import { put, call } from 'redux-saga/effects';

import { actions as errorActions } from '@blueberry/redux/error';
import {
  fetchSubjectPageFailure,
  fetchSubjectPageSuccess,
} from '@blueberry/redux/subjectPage';
import { actions as channelActions } from '@blueberry/redux/channel';
import { changePosts } from '@blueberry/redux/pagePost';

import {
  getSubjectPage,
  transferPostWithoutDescription,
  getSubtopicPage,
} from '@blueberry/services/contents';

const SUBJECT = 'subject';

export function* fetchSubjectPageFlow(action) {
  try {
    const { id } = action.payload;

    const name = `${SUBJECT}-${id}`;

    const {
      channels: channelResp,
      related_posts: relatedPosts,
      curriculum,
      subject,
    } = yield call(getSubjectPage, name);

    // update channel
    const channels = channelResp.map(channel => ({
      id: channel.id,
      name: channel.title,
      posts: channel.posts.map(transferPostWithoutDescription),
    }));
    yield put(channelActions.changeChannels(channels));

    // update posts
    const posts = relatedPosts.map(transferPostWithoutDescription);
    yield put(changePosts(posts));

    yield put(fetchSubjectPageSuccess({ curriculum, subject }));
  } catch (err) {
    yield put(fetchSubjectPageFailure(err));
    yield put(errorActions.sendError(err));
  }
}

export function* fetchSubtopicPageFlow(action) {
  try {
    const { id } = action.payload;

    const { curriculum, subject, subtopic, posts: postResp } = yield call(
      getSubtopicPage,
      id
    );

    // update posts
    const posts = postResp.map(transferPostWithoutDescription);
    yield put(changePosts(posts));

    yield put(fetchSubjectPageSuccess({ curriculum, subject, subtopic }));
  } catch (err) {
    yield put(fetchSubjectPageFailure(err));
    yield put(errorActions.sendError(err));
  }
}



// WEBPACK FOOTER //
// ./app/sagas/subjectPage.js